import { atom } from "jotai";
export const mapBoundsAtom = atom(null);
export const selectedPlaceIdAtom = atom(null);